import lottie from "lottie-web";
import { canv } from "@/canv/global";

export class LoadingAnimation {
    src: string;
    width: number;
    height: number;

    private animation?: ReturnType<typeof lottie.loadAnimation>;
    private internalCanvas: HTMLCanvasElement;
    private internalCtx!: CanvasRenderingContext2D;
    private isReady = false;

    constructor(src: string, width = 0, height = 0) {
        this.src = src;
        this.width = width;
        this.height = height;
        this.internalCanvas = document.createElement("canvas");
    }

    async init() {
        this.internalCtx = this.internalCanvas.getContext("2d") as CanvasRenderingContext2D;

        const resp = await fetch(this.src);
        const json = await resp.json();

        // Удаляем фон, у анимации есть белый фон, он мешает
        if (json.layers) {
            json.layers = json.layers.filter((layer: unknown) => {
                return (
                    typeof layer === "object" &&
                    layer !== null &&
                    "nm" in layer &&
                    (layer as { nm?: string }).nm !== "Background"
                );
            });
        }

        //Нужен, т.к. неверная типизация у параметров и она требует контейнер, который ломает работу анимации
        //@ts-ignore
        this.animation = lottie.loadAnimation<"canvas">({
            animationData: json,
            renderer: "canvas",
            loop: true,
            autoplay: true,
            rendererSettings: {
                context: this.internalCtx,
                clearCanvas: true,
            },
        });

        this.animation.addEventListener("DOMLoaded", () => {
            this.isReady = true;
            canv.redraw();
        });

        this.animation.addEventListener("enterFrame", () => {
            canv.redraw();
        });
    }

    draw(startX: number, startY: number) {
        if (!this.isReady) {
            return;
        }

        canv.ctx.save();

        canv.ctx.globalCompositeOperation = "multiply";

        canv.ctx.drawImage(this.internalCanvas, startX, startY, this.width, this.height);

        canv.ctx.restore();
    }

    destroy() {
        this.animation?.destroy();
    }
}
